import styled from 'styled-components'

export const Button = styled.button`
  margin: 0 8px;
  width: 2rem;
  height: 2rem;
  border: 1px solid ${props => props.theme.colors.colordfe3e8};
  padding: 3px;
  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: 4px;
  cursor: pointer;

  svg {
    fill: ${props => props.theme.colors.colora7abb2};
    transition: all 0.15s ease-in-out;
  }

  &:hover svg {
    fill: ${props => props.theme.colors.color6b7786};
  }

  &:disabled {
    fill: ${props => props.theme.colors.colordfe3e8};
    background: ${props => props.theme.colors.colore9ecf3};
  }
`
